module.exports = __webpack_public_path__ + "img/mc.4b295968.svg";